module.exports = __webpack_public_path__ + "img/6.69890622.png";